import Tabs, { ITab } from "@/components/Tabs";
import { HeaderTextBlock, TypographyContainer } from "@/components/Typography";
import { IFeatureFlagKeys } from "@/utils/featureFlags";
import { useFlags } from "flagsmith/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const IntegrationController = () => {
  const { t } = useTranslation();
  const flags = useFlags<IFeatureFlagKeys>(["klaviyo-phone-numbers-enabled"]);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname.endsWith("integration")) navigate("klaviyo-api-key");
  }, [pathname]);

  const tabs: ITab[] = [
    {
      title: t("settings.integration.tabs.klaviyoKey"),
      path: "klaviyo-api-key",
    },
    {
      title: t("settings.integration.tabs.klaviyoPhoneNumbers"),
      path: "klaviyo-phone-numbers",
      isVisible: flags?.["klaviyo-phone-numbers-enabled"]?.enabled,
    },
    {
      title: t("settings.integration.tabs.klaviyoLists"),
      path: "klaviyo-lists",
    },
    {
      title: t("settings.integration.tabs.shopifyApp"),
      path: "shopify-app",
    },
  ];

  return (
    <>
      <TypographyContainer>
        <HeaderTextBlock
          align="left"
          featureText={t("settings.integration.header.feature")}
          headingText={t("settings.integration.header.heading")}
        />
      </TypographyContainer>
      <div className="mt-2">
        <Tabs tabs={tabs} />
        <div className="mt-50">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default IntegrationController;
